import { BaseTheme as Theme } from '@blockanalitica/ui/package/types/src/theme/baseTheme';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function kpiCardFooter(theme: Theme): ComponentStyle {
  return {
    componentName: 'kpiCardFooter',
    baseStyle: {
      fontSize: theme.sizes[0],
      color: theme.colors.muted
    },
    variants: {
      sharedTitle: {
        fontSize: theme.sizes[1]
      },
      singleTitle: {
        fontSize: theme.sizes[1]
      }
    }
  };
}
